var map = {
	"./hero-logo.svg": [
		117,
		117
	],
	"./icon-arrow-back.svg": [
		2208,
		208
	],
	"./icon-arrow-disabled.svg": [
		3077,
		77
	],
	"./icon-arrow-down.svg": [
		2449,
		449
	],
	"./icon-arrow-hover.svg": [
		1573,
		573
	],
	"./icon-arrow.svg": [
		576,
		576
	],
	"./icon-close-white.svg": [
		1467,
		467
	],
	"./icon-error.svg": [
		9089,
		89
	],
	"./kollectiff.svg": [
		9768,
		768
	],
	"./logo-white.svg": [
		7270,
		270
	],
	"./scroll-top-hover.svg": [
		4619,
		619
	],
	"./scroll-top.svg": [
		4682,
		682
	],
	"./social-instagram-fill.svg": [
		1785,
		785
	],
	"./social-instagram.svg": [
		3229,
		229
	],
	"./social-linkedin-fill.svg": [
		6789,
		789
	],
	"./social-linkedin.svg": [
		1425,
		425
	],
	"./social-x-fill.svg": [
		6701,
		701
	],
	"./social-x.svg": [
		7913,
		913
	],
	"./spinner.svg": [
		3126,
		126
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4259;
module.exports = webpackAsyncContext;